import { AdvancedPaymentTaxModel } from './advancedPaymentTax.model';

export class AdvancedPaymentLineModel {
    product: string;
    quantity: number;
    discount: number;
    unityAmount: number;
    taxes: Array<AdvancedPaymentTaxModel>;

    constructor() {
        this.taxes = new Array<AdvancedPaymentTaxModel>();
        this.discount = 0;
        this.quantity = 0;
        this.unityAmount = 0;
    }
}
